import React from 'react';
import DamageMap from './DamageMap';
import './DamageMapSection.css';

const DamageMapSection = () => {
  return (
    <section id="damage-map" className="damage-map-section">
      <div className="container">
        <div className="section-header">
          <h2>🛰️ AI Damage Assessment Map</h2>
          <p>Real-time satellite analysis showing verified damage</p>
        </div>
        
        <div className="damage-map-wrapper">
          <DamageMap />
        </div>
        
        <div className="map-info">
          <div className="info-grid">
            <div className="info-card">
              <h4>🤖 AI-Powered Analysis</h4>
              <p>Satellite imagery processed using advanced machine learning to identify structural damage</p>
            </div>
            <div className="info-card">
              <h4>📊 Real-Time Updates</h4>
              <p>Numbers represent building counts in each area. Click to zoom and explore detailed assessments</p>
            </div>
            <div className="info-card">
              <h4>🎯 Precision Targeting</h4>
              <p>Helps aid organizations prioritize resources where they're needed most</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DamageMapSection;
